import environmentWeb from '@ktag/styleguide/src/javascripts/config/environment-web';

const environmentQV = {};

// if you want to extend/enhance the default config
// with your own rules, you can do so here, by overriding
// the config, by using object.assign such as this:
//
// const environmentQv = {
//   test: {
//     hostname: 'anotherhostname',
//   },
//   production: {
//     analytics: {
//       trackers: [
//         {
//           name: 'customTrackerId',
//           trackerId: 'UA-XXXXXXXX-1',
//         },
//       ],
//     },
//   },
// };

export default Object.assign(environmentWeb, environmentQV);
